<div [ngClass]="getEditorClasses()" [ngStyle]="getEditorStyles()">
  <span *ngIf="canFullscreen && !fullscreen" class="fullscreen-toggle" (click)="toggleFullscreen()">
    <mat-icon>fullscreen</mat-icon>
  </span>
  <ng-container *ngIf="!fullscreen">
    <ace *ngIf="required" [config]="config"
         required
         [disabled]="disabled"
         (blur)="onEditorBlur($event)"
         (focus)="onEditorFocus($event)"
         (valueChange)="onValueChange($event)"
         [(value)]="text">
    </ace>
    <ace *ngIf="!required" [config]="config"
         [disabled]="disabled"
         (blur)="onEditorBlur($event)"
         (focus)="onEditorFocus($event)"
         (valueChange)="onValueChange($event)"
         [(value)]="text">
    </ace>
  </ng-container>
</div>

<style>
  .micro-ace-editor-container {
    position: relative;
  }

  .micro-ace-editor-container .fullscreen-toggle {
    position: absolute;
    top: -4px;
    left: -4px;
    font-size: 20px;
    background: rgba(128,128, 128, 0.25);
    padding: 4px 4px 0 4px;
    border-radius: 4px;
    cursor: pointer;
    z-index: 10000;
    user-select: none;
  }

</style>
